import {
    FilterConfig, convertObjectValueToFilter, convertFilterValueToObjectSelector,
} from 'app/hooks/useFilter'
import {
    FilterType,
} from 'app/enums/common.enums'

const filterConfig: FilterConfig<'contractBasis'> = {
    contractBasis: {
        filterField: 'contractBasisId',
        filterType: FilterType.Array,
        preselectOptions: {
            componentName: 'ContractBasisSelector',
            filterToValueConverter: convertFilterValueToObjectSelector,
            onChangeConverter: convertObjectValueToFilter,
            placeholder: 'Select Contract Basis',
            noneOption: false,
        },
    },
}

export default filterConfig
